module.exports = __webpack_public_path__ + "media/img/manual-testing/manual-banner-icon-80d835dafc266957ee5a55399afbf834.svg";